import { getAddressStringByGoogleLocation } from "../features/job/creation/assets/jobCreationUtill";
import { useGetEntityIdMutation } from "../features/users/listing/userApiSlice";


export const useFetchTranslation = () => {

  const [getEntity] = useGetEntityIdMutation();

  const fetchTranslation = async (prefix, id, fullCode) => {
    try {
      const res = await getEntity({ entityKey: fullCode }).unwrap();
      if (!res || !res.data) return null;
      
      const { statusId,title, url, campaignName, firstName, lastName, centralLocation } = res.data;
    return {
        label:
          prefix === 'camp'
            ? campaignName
            : prefix === 'hp'
              ? getAddressStringByGoogleLocation(centralLocation,['postalTown', 'postalCode'])
              : prefix === 'cand'
                ? `${firstName} ${lastName}`
                : title,
        url: url || `/details/${prefix}/${id}`,
        status:statusId,
        data:res?.data,
        prefix:prefix
      };
    } catch (error) {
      console.error('Error fetching translation:', error);
      return null;
    }
  };

  return { fetchTranslation };
};
